"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinChildren = void 0;
const react_1 = __importDefault(require("react"));
const shouldReplaceKey = (key) => {
    return !key || /\.[0-9]+/.test(key);
};
const joinChildren = (children, separator) => {
    const kids = [];
    const arr = react_1.default.Children.toArray(children);
    if (!arr)
        return null;
    for (let i = 0; i < arr.length; i++) {
        if (typeof arr[i] === "object") {
            const el = arr[i];
            kids.push(react_1.default.cloneElement(el, {
                ...el.props,
                key: shouldReplaceKey(el.key) ? `el-${i}` : el.key,
            }));
        }
        else {
            kids.push(arr[i]);
        }
        if (i < arr.length - 1) {
            kids.push(react_1.default.cloneElement(separator, {
                ...separator.props,
                key: `join-${i}`,
            }));
        }
    }
    return kids;
};
exports.joinChildren = joinChildren;
